var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "b-row",
    {
      staticClass: "fup-paginator",
      attrs: { "align-v": "center", "align-h": "between" }
    },
    [
      !_vm.minimize
        ? _c(
            "b-col",
            { staticClass: "text-muted pl-0" },
            [
              _vm.perPage
                ? [
                    _vm._v(
                      "\n            " +
                        _vm._s(_vm.perPage * _vm.value - _vm.perPage + 1) +
                        " – " +
                        _vm._s(
                          _vm.perPage * _vm.value > _vm.totalRows
                            ? _vm.totalRows
                            : _vm.perPage * _vm.value
                        ) +
                        "\n            "
                    ),
                    (_vm.perPage * _vm.value > _vm.totalRows
                      ? _vm.totalRows
                      : _vm.perPage * _vm.value) < 9999
                      ? [
                          _vm._v(
                            "\n                из " +
                              _vm._s(_vm.totalRows) +
                              "\n            "
                          )
                        ]
                      : _vm._e()
                  ]
                : _vm.totalRows
                ? [
                    _vm._v(
                      "\n            Всего " +
                        _vm._s(_vm.totalRows) +
                        "\n        "
                    )
                  ]
                : _vm._e()
            ],
            2
          )
        : _vm._e(),
      _vm._v(" "),
      _vm.perPage && _vm.totalRows > _vm.perPage
        ? _c(
            "b-pagination",
            _vm._b(
              {
                staticClass: "m-0",
                attrs: {
                  size: "sm",
                  "total-rows": _vm.totalRows,
                  value: _vm.value,
                  "per-page": _vm.perPage
                },
                on: { input: _vm.changed }
              },
              "b-pagination",
              _vm.$attrs,
              false
            )
          )
        : _vm._e()
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }